module.exports = __webpack_public_path__ + "static/media/t22.d7474710.jpg";